import Store from "../SessionStorage";
import { sessionStorageAction } from "./";

/** TO DELETE **/
export const getDataPagePWYD = key => {};
export const getTagsATInternet = key =>
  window.tagsATInternet.filter(dataPage => dataPage.key === key)[0].data;
export const getDataPageLinks = key =>
  window.tagsLinks.filter(dataPage => dataPage.key === key)[0].data;

const parsedURL = () => window.location.href.split("/").slice(4);

const getStepName = step => {
  const steps = [
    "conditions",
    "vehicule",
    "conducteur",
    "devis",
    "souscripteur",
    "recapitulatif"
  ];
  const isHamon = Store.get(sessionStorageAction.cache.devis.devisVehicle)
    ? Store.get(sessionStorageAction.cache.devis.devisVehicle).alreadyContracted
    : false;
  const showBankFormSession = Store.get(sessionStorageAction.cache.showBankForm)
    ? new Boolean(Store.get(sessionStorageAction.cache.showBankForm))
    : false;

  if (step < 6) {
    return steps.filter((s, i) => steps.indexOf(s) === step)[0];
  } else {
    if (showBankFormSession) {
      return "finalisation";
    } else {
      return "hamon";
    }
  }
};

const getEventLoadPageObject = (data, index, array) => {
  if (index + 1 === array.length) {
    return { name: data, level2: 1 };
  } else {
    return { [`chapter${index + 1}`]: data };
  }
};

export const sendTag = (name) => {
  let tag = {};
  parsedURL().forEach((data, index, array) => {
    tag = Object.assign(tag, getEventLoadPageObject(data, index, array));
  });
  tag.name = name;
  window.handleEventPageATInternet && window.handleEventPageATInternet(tag);
}

// DISPATCH LOAD PAGE TAG
export const dispatchLoadPageTag = () => {
  let tag = {};
  parsedURL().forEach((data, index, array) => {
    tag = Object.assign(tag, getEventLoadPageObject(data, index, array));
  });
  window.handleEventPageATInternet && window.handleEventPageATInternet(tag);
};

// DISPATCH EVENT DATA TAG
export const dispatchEventDataTag = data => {
  let page = {};
  let customVars = {};
  parsedURL().forEach((data, index, array) => {
    page = Object.assign(page, getEventLoadPageObject(data, index, array));
  });
  Object.keys(data).forEach((key, index, array) => {
    customVars = Object.assign(customVars, {
      [index + 1]:
        data[key] &&
        JSON.stringify(data[key]) &&
        JSON.stringify(data[key]).replace(/\s/g, "_")
    });
  });
  window.handleEventDataATInternet &&
    window.handleEventDataATInternet(page, customVars);
};

// DISPATCH EVENT CLICK TAG
export const dispatchEventClickTag = (name, zone, step, type) => {
  const transformName = name && name.replace(/\s/g, "_");
  let tag = {
    name: transformName,
    chapter1: step,
    chapter2: zone.length > 0 ? zone : undefined,
    level2: 1,
    type
  };
  window.handleEventClickATInternet && window.handleEventClickATInternet(tag);
};

export const dispatchEventErrorTag = codeErreur => {
  let page = {
    name: "page-erreur",
    level2: 1
  };
  let customVars = {
    1: codeErreur,
    2: window.location.href
  };
  window.handleEventDataATInternet &&
    window.handleEventDataATInternet(page, customVars);
};
